import { render, staticRenderFns } from "./XwdtPageLayout.vue?vue&type=template&id=45a47fb8&scoped=true"
import script from "./XwdtPageLayout.vue?vue&type=script&lang=js"
export * from "./XwdtPageLayout.vue?vue&type=script&lang=js"
import style0 from "./XwdtPageLayout.vue?vue&type=style&index=0&id=45a47fb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a47fb8",
  null
  
)

export default component.exports